export const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://91.n/#organization",
      "name": "91.n",
      "url": "https://91.n",
      "description": "值得信赖的网络导航入口，提供快速、安全、便捷的访问体验",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "contact@91.n",
        "contactType": "customer service"
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://91.n/#website",
      "name": "91.n",
      "url": "https://91.n",
      "description": "值得信赖的网络导航入口",
      "inLanguage": "zh-CN",
      "publisher": {
        "@id": "https://91.n/#organization"
      }
    },
    {
      "@type": "WebPage",
      "@id": "https://91.n/#webpage",
      "url": "https://91.n",
      "name": "91.n 官方入口导航",
      "description": "91.n 是您值得信赖的网络导航入口，提供快速、安全、便捷的访问体验",
      "inLanguage": "zh-CN",
      "isPartOf": {
        "@id": "https://91.n/#website"
      },
      "about": {
        "@id": "https://91.n/#organization"
      }
    }
  ]
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "91.n 是什么？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "91.n 是一个专业的网络导航入口平台，为您提供分类清晰、资源丰富的网站导航服务。"
      }
    },
    {
      "@type": "Question",
      "name": "91.n 是免费使用的吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "是的，91.n 完全免费。我们的目标是让每一位用户都能享受便捷高效的网络导航服务。"
      }
    },
    {
      "@type": "Question",
      "name": "如何找到 91.n 的最新访问地址？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "您可以直接访问我们的官方域名。如域名有更新，我们会通过官方网站公告、社交媒体等渠道及时通知用户。"
      }
    },
    {
      "@type": "Question",
      "name": "91.n 收录的网站安全吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "我们对所有收录的网站进行严格的审核和定期检查，确保链接的有效性和安全性。"
      }
    },
    {
      "@type": "Question",
      "name": "可以推荐网站加入 91.n 的导航列表吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "当然可以！我们非常欢迎用户推荐优质网站。请通过「关于我们」页面的联系方式提交您的推荐。"
      }
    },
    {
      "@type": "Question",
      "name": "91.n 在手机端可以使用吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "可以。91.n 采用响应式设计，完美适配手机、平板和桌面设备。"
      }
    },
    {
      "@type": "Question",
      "name": "91.n 会收集用户的个人隐私信息吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "91.n 高度重视用户隐私保护。我们不要求用户注册登录，也不会收集任何个人身份信息。"
      }
    }
  ]
};

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const articleSchema = (article: { title: string; excerpt: string; createdAt: string }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.title,
  "description": article.excerpt,
  "datePublished": article.createdAt,
  "author": {
    "@type": "Organization",
    "name": "91.n"
  },
  "publisher": {
    "@type": "Organization",
    "name": "91.n",
    "url": "https://91.n"
  }
});

export const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "关于 91.n",
  "description": "91.n 是一个致力于为用户提供高效、安全、便捷网络导航服务的专业平台。",
  "url": "https://91.n/about"
};